import restClient from "../restClient";

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const sendMail = async (data) => {
  try {
    const response = await restClient.post(`mail-service/send`, { data }, authConfig());
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const sendBulkMailToCustomers = async ({ customer_ids, selection, subject, message, template_id }) => {
  const response = await restClient.post(
    "mail-service/customers/bulk-send",
    { customer_ids, selection, subject, message, template_id },
    authConfig()
  );
  return response.data;
};
